import type { RequiredKeys } from '@/utils/types';
import type { Props as JobEditDialogProps } from '@/components/pageDialogs/JobEditDialog.vue';

import { reactive } from 'vue';
import { defineStore } from 'pinia';
import _cloneDeep from 'lodash/cloneDeep';

export interface DefPageDialogState {
  jobEdit: RequiredKeys<{
    isOpen: boolean | undefined;
    dialogData: RequiredKeys<JobEditDialogProps>;
  }>;
}

const defPageDialogState: DefPageDialogState = {
  jobEdit: {
    isOpen: undefined,
    dialogData: {
      jobId: undefined,
      jobDate: undefined,
      jobs: [],
      onDataChanged: undefined,
    },
  },
};

interface OpenParams {
  jobEdit: JobEditDialogProps;
}

type PageDialogName = keyof DefPageDialogState;

function pageDialogStoreSetup() {
  const state = reactive<DefPageDialogState>({
    jobEdit: {
      isOpen: undefined,
      dialogData: {
        jobId: undefined,
        jobDate: undefined,
        jobs: [],
        onDataChanged: undefined,
      },
    },
  });

  function open<T extends PageDialogName>(
    dialogName: T,
    dialogData: OpenParams[T] = {},
  ): void {
    const oneDialogState = state[dialogName];

    Object.assign(oneDialogState.dialogData, dialogData);
    oneDialogState.isOpen = true;
  }

  function close(dialogName: PageDialogName): void {
    const oneDialogState = state[dialogName];
    oneDialogState.isOpen = false;

    const oneDefDialogState = defPageDialogState[dialogName];
    Object.assign(oneDialogState.dialogData, oneDefDialogState.dialogData);
  }

  function $reset(): void {
    const resetState = _cloneDeep(defPageDialogState);
    state.jobEdit.isOpen = resetState.jobEdit.isOpen;
    state.jobEdit.dialogData = resetState.jobEdit.dialogData;
  }

  return {
    ...state,
    open,
    close,
    $reset,
  };
}

export const usePageDialogStore = defineStore(
  'pageDialog',
  pageDialogStoreSetup,
);
